<template>

    <div class="layout__container">

        <h3 class="text__align-center text__colour-teal">Monthly Invoicing List</h3>

        <div class="layout__position-center">
            <div class="layout__position-left layout__width-100">
                <MonthlyInvoicingListSearch v-bind:searchParams="searchParams" v-bind:sales="sales"></MonthlyInvoicingListSearch>
            </div>

            <div class="insights-table layout__width-100 layout__position-left">
                <div class="el-table__scroll-wrapper">
                    <div class="el-table__scroll-div">
                    </div>
                </div>
                <el-table class="el-table__09vh layout__height-1240px layout__scrolling__right" :data="sales.slice(this.start-1, this.end)" style="width: 100%;" @sort-change="handleSortOrderChange" 
                v-loading.fullscreen.lock="loading" element-loading-text="Loading..." element-loading-background="rgba(79, 147, 168, 0.2)" empty-text="No data has been returned for the selected dates">
                    <el-table-column prop="type" label="Type" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="status" label="Status" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="bill_month" label="Bill Month" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" :formatter="getMonthName">
                    </el-table-column>
                    <el-table-column prop="bill_year" label="Bill Year" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="branch" label="Branch" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="name" label="Name" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="head_office" label="Head Office" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="net_total" label="Net Total" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" :formatter="getCurrencyAmount">
                    </el-table-column>
                    <el-table-column prop="territory" label="Territory" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="brand" label="Brand" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="first_order" label="First Order" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" :formatter="getFormattedDate" width="100px">
                    </el-table-column>
                    <el-table-column prop="last_order" label="Last Order" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" :formatter="getFormattedDate" width="100px">
                    </el-table-column>
                    <el-table-column prop="address1" label="Address Line 1" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="address2" label="Address Line 2" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="town" label="Town" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="100px">
                    </el-table-column>
                    <el-table-column prop="county" label="County" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="100px">
                    </el-table-column>
                    <el-table-column prop="postcode" label="Postcode" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="software" label="Software" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="netsuite_id" label="Netsuite ID" class-name="layout__width-10 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                    <el-table-column prop="salesforce_id" label="Salesforce ID" class-name="layout__width-5 el-table-column__no-pointer" sortable="custom" width="150px">
                    </el-table-column>
                </el-table>
            </div>
            <div class="">
                <div class="layout__padding-clear layout__padding-8-0 layout__border__all-1px">
                    <div class="text__align-center layout__padding-8-0">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[20, 40, 60, 80, 100, 200]"
                            :page-size="200"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="this.sales.length">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

    import moment from 'moment';
    import Axios from 'axios';
    import download from 'downloadjs';
    import MonthlyInvoicingListSearch from '@/components/insights/MonthlyInvoicingListSearch';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {sortJsonArrayHelper} from '@/mixins/sort-json-array.js';
 
    export default {
        name: "sales",
        mixins: [axios, dataFormatter, sortJsonArrayHelper],
        components: {
            MonthlyInvoicingListSearch
        },
        props: {
            view: ''
        },
        data() {
            return {
                selectedBillMonth: '',
                selectedBillYear: '',
                sales: [],
                start: 1,
                end: 200,
                pagination: 200,
                loading: false,
                serviceRouteUrl: `${process.env.VUE_APP_INSIGHTSAPIHOST}`,
                exportDate: new Date().toLocaleDateString('en-GB') + '_sales.csv',
                searchParams: {
                    billingDate: new Date().toLocaleDateString('en-GB'),
                },
            }
        },
        created() {
            this.isUserAuthorised();
        },
        mounted() {
            var bw = document.getElementsByClassName("el-table__body-wrapper");
            bw[0].addEventListener('scroll', this.handleScroll1);
            var sw = document.getElementsByClassName("el-table__scroll-wrapper");
            sw[0].addEventListener('scroll', this.handleScroll2);
        },
        updated() {
            var h = document.getElementsByClassName("el-table__header");
            var sd = document.getElementsByClassName("el-table__scroll-div");
            sd[0].style.width = h[0].style.width;

            var bw = document.getElementsByClassName("el-table__body-wrapper");
            if (bw[0].scrollWidth > bw[0].clientWidth) {
                sd[0].style.display = "block";
            } else {
                sd[0].style.display = "none";
            }
        },
        methods: {
            handleScroll1(e) {
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                sw[0].scrollLeft = bw[0].scrollLeft;
            },
            handleScroll2(e) {
                var sw = document.getElementsByClassName("el-table__scroll-wrapper");
                var bw = document.getElementsByClassName("el-table__body-wrapper");
                bw[0].scrollLeft = sw[0].scrollLeft;
            },
            getMonthName(row, column) {
                let monthNames = ["JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"];
                return monthNames[row.bill_month - 1];
            },
            getCurrencyAmount(row, column, cellValue) {
                if (typeof cellValue === 'undefined') {
                    return '£0'
                } else {
                    return '£' + cellValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            },
            getFormattedDate(row, column, cellValue) {
                let dateTimeArray = cellValue.toString().split(/ (.+)/);
                let dateArray = dateTimeArray[0].toString().split("/");
                return dateArray[1] + '/' + dateArray[0] + '/' + dateArray[2] + ' ' + moment(dateTimeArray[1], 'hh:mm:ss A').format('HH:mm:ss');
            },
            handleSizeChange(val) {
                console.log(`${val} items per page`);

                this.pagination = val
                console.log(this.start)
                this.end = this.pagination;
                console.log(this.end)
            },
            handleCurrentChange(val) {
                console.log(`current page: ${val}`);

                this.start = (val - 1) * this.pagination + 1;
                console.log(this.start)
                this.end = val * this.pagination;
                console.log(this.end)
            },
            handleSortOrderChange(sortProps) {
                console.log('prop: ' + sortProps.prop);
                console.log('order: ' + sortProps.order);

                this.sortJsonArray(this.sales, sortProps.prop, sortProps.order.slice(0, 3));
            }
        }
    };
</script>